import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { EntryType } from 'components/registry/types/api';
import { ReportModal } from 'components/ReportModal';
import { useUserDataContext } from 'components/UserDataContext/context';
import { useGetPermission } from 'utils/hooks/useGetPermission';
import { getIsActual } from 'utils/getIsActual';
import { ROLES } from 'utils/consts/roles';
import { FileType } from 'types/types';
import { PharmPermissionDTO } from '../../types/types';
import { pharmPermissionsApi } from '../../api';
import { RequestMotion } from './components/RequestMotion';
import { Information } from './components/Information';

type ViewFormProps = {
  data: PharmPermissionDTO<FileType>;
  registryLink: string;
  entryType?: EntryType;
  updateData: () => void;
};

export const ViewForm = ({ data, registryLink, entryType, updateData }: ViewFormProps) => {
  const { userData } = useUserDataContext();
  const reportCreateDate = new URLSearchParams(window.location.search).get('reportCreateDate');
  const [isActualModalOpen, setIsActualModalOpen] = useState(!!reportCreateDate);

  const permissions = {
    edit: useGetPermission(ROLES.permits, userData, true),
    remove: useGetPermission(ROLES.permits, userData, true),
    rshsn: useGetPermission(ROLES.rshsnPharmPerm, userData),
    patentee: useGetPermission(ROLES.patenteePharmPerm, userData),
    elk: useGetPermission(ROLES.elk, userData),
    erul: useGetPermission(ROLES.erul, userData),
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Information
          data={data}
          registryLink={registryLink}
          removeMethod={pharmPermissionsApi.deleteCard}
          permissions={permissions}
          entryType={entryType}
          userData={userData}
          updateData={updateData}
        />
      </Grid>
      {(permissions.patentee || permissions.rshsn) &&
        data.movementList &&
        data.movementList.length > 0 && (
          <Grid item xs={12}>
            <RequestMotion
              id={data.id!}
              cardData={data}
              history={data.movementList}
              permissions={permissions}
              updateData={updateData}
            />
          </Grid>
        )}
      {reportCreateDate && isActualModalOpen && (
        <ReportModal
          onClose={() => {
            setIsActualModalOpen(false);
          }}
          label="Выписка из перечня разрешений на ввод в гражданский оборот иммунобиологических лекарственных препаратов для ветеринарного применения"
          isActual={getIsActual(reportCreateDate, data.stamp?.changeDate)!}
          reportCreateDate={reportCreateDate}
        />
      )}
    </Grid>
  );
};
